import './table'
import airTable from './table/index.vue'
import airTabs from './tabs'
import airConfirm from './confirm'
import airConfirmV2 from './confirm/v2'
import airFooterBar from './footer/footer-bar'
import airUploadFile from './upload/file'
import airUploadExcel from './upload/excel'
import bspPagination from '@/components/bsp/bsp-pagination/bsp-pagination';
import bspEmpty from '@/components/bsp/bsp-empty/bsp-empty';

export default {
  install(Vue, options) {
    Vue.component(airTable.name, airTable)
    Vue.component(airTabs.name, airTabs)
    Vue.component(airConfirm.name, airConfirm)
    Vue.component(airConfirmV2.name, airConfirmV2)
    Vue.component(airFooterBar.name, airFooterBar)
    Vue.component(airUploadFile.name, airUploadFile)
    Vue.component(airUploadExcel.name, airUploadExcel)
    Vue.component(bspPagination.name, bspPagination)
    Vue.component(bspEmpty.name, bspEmpty)
  }
}
